// CHID-2  Mahesh   17/01/2020    standByMD-1971: Symptom Selector Implementation(few modification is done)
import { classnames as cx } from '@mna/react'
import IconAdd from 'assets/icons/add.svg'
import IconX from 'assets/icons/x.svg'
import {Trans} from 'react-i18next'
export default ({
    results,
    symptomsAdded,
    currentSymptomTitles,
    actions,
    setModalState,
    symptomSearchText
}) =>
    <div>
        <div style={{ paddingBottom: '15px' }}>
            <span className="symptom-content"><Trans i18nKey="findcareoption.SymptomSelector.pleaseselect">  Please select whichever best describes your symptom..</Trans></span>
        </div>
        <ul className="standby-symptom-list">
            {results.map((symptom, symptomIndex) => {
                const isSymptomAdded = symptomsAdded.includes(symptom.common_name)
                    || currentSymptomTitles.includes(symptom.common_name)
                return (
                    <li className="standby-symptom-list-nlpitem"
                        key={`symptom-result-${symptom.id}`}
                    >
                        <button type="button"
                            className={
                                cx("button standby-symptom-button",
                                    isSymptomAdded ? 'standby-symptom-button-add' : 'standby-symptom-button-remove'
                                )}
                            onClick={() => {
                                if (isSymptomAdded) {
                                    actions.removeSymptom({ symptom })
                                    setModalState({
                                        symptomsAdded: symptomsAdded.filter(common_name => common_name !== symptom.common_name)
                                    })
                                    return
                                }
                                actions.addSymptom({ symptom })
                                setModalState({
                                    symptomsAdded: [
                                        ...(symptomsAdded || []),
                                        symptom.common_name
                                    ], symptomSearchText:''
                                })
                            }}
                        >
                            <div className="standby-symptom-button-text">{symptom.common_name}</div>
                            <div className="icon icon-add-symptom">
                                <IconAdd id={symptom.common_name} />
                            </div>
                        </button>
                    </li>
                )
            })}
        </ul>
    </div>
